<template>
	<div>
		<div class="row">
			<div class="mb-3">
				<el-collapse>
					<el-collapse-item>
						<template slot="title">
							<span style="color:#606266;font-size:14px;"><i class="header-icon el-icon-search"></i>&nbsp;&nbsp;&nbsp;Filter</span>
						</template>
						<el-form label-position="top" label-width="100px">
							<div class="row">
								<div class="col-md-6">
									<el-form-item label="BranchID Penerima:">
										<el-select v-model="filter.branchto" clearable filterable placeholder="Select Branch" size="medium" style="width:100%;">
											<el-option v-for="(item3, index) in branchlistrecipient" :key="item3.BranchIDTerima + '_' + index" :label="item3.BranchNameTerima" :value="item3.BranchIDTerima">
											</el-option>
										</el-select>
									</el-form-item>
								</div>

								<div class="col-md-6">
									<el-form-item label="BranchID Pengirim:">
										<el-select v-model="filter.branch" clearable filterable placeholder="Select Branch" size="medium" style="width:100%;">
											<el-option v-for="(item3, index) in branchlistsender" :key="item3.BranchID + '_' + index" :label="item3.BranchName" :value="item3.BranchID">
											</el-option>
										</el-select>
									</el-form-item>
								</div>

							</div>

							<div class="row">
								<div class="col-md-5">
									<el-form-item label="Date Range:">
										<div class="block">
											<el-date-picker
											v-model="filter.dateRange"
											type="daterange"
											align="right"
											unlink-panels
											range-separator="-"
											start-placeholder="Start date"
											end-placeholder="End date"
											format="yyyy-MM-dd"
											value-format="yyyy-MM-dd"
											:picker-options="pickerOptions">
											</el-date-picker>
										</div>
									</el-form-item>
								</div>
							</div>

							<div class="row">
								<div class="col-md-5">
									<el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply Filter</el-button>
								</div>
							</div>
						</el-form>
					</el-collapse-item>
				</el-collapse>
			</div>

			<div class="row">
				<div class="col-md-3 mb-3">
					<el-checkbox v-model="showchart">Show Chart</el-checkbox>
				</div>
				<div class="col-md-4 mb-3" v-if="showchart">
					<el-radio-group v-model="charttype">
						<el-radio label="barchart" size="small">Bar Chart</el-radio>
						<el-radio label="linechart" size="small">Line Chart</el-radio>
						<el-radio label="piechart" size="small" v-if="false">Pie Chart</el-radio>
					</el-radio-group>
				</div>

			</div>
			<div class="mb-0" >
				<BarChart v-loading.body="loading.table" :data="chartdata" :width="500" :height="380" v-if="showchart && charttype=='barchart'" />
				<LineChart v-loading.body="loading.table" :data="chartdata" :width="500" :height="192" v-if="showchart && charttype=='linechart'" style="margin-top:20px;"/>
				<PieChart v-loading.body="loading.piechart" :data="piechartdata" :url="''" v-if="showchart && charttype=='piechart'" style="width:250px;" />
			</div>

			<div class="mt-0">
				<ReportResultTable :reportname="'ItemQuotaReport'" :reportdata="reportdata" :loading="loading.table" :reporturl="urlRequestParams" :issuccess="loading.isSuccess" style="width:100%;"/>
			</div>
		</div>
	</div>
</template>

<script>

import Bright from '@/components/page/Bright.js'
import ReportParamSelect from '@/views/pages/ReportParamSelect.vue'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import { Rainbow, AxiosWithJar, Config} from '@/utility.js'
import Loader from '@/components/loader/Loader.vue'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'
import PieChart from '@/components/chart/Pie.js'

export default
{
	extends: Bright,
	props: ['tabIndex','tabName', 'tabLabel'],
	components: {
		//ReportParamSelect,
		ReportResultTable,
		LineChart,
		BarChart,
		PieChart,
		//Loader,
	},

	data(){
		return {
			filter: {
				branch: this.$route.query.branch ? this.$route.query.branch : '',
				branchto: this.$route.query.branch ? this.$route.query.branch : '',
				metric: '',
				area: '',
				category: '',
				metricName: 'Self-service sales (IDR)',
				startDate: '',
				endDate: '',
				dateRange: [],
			},
			loading: {
				table: false,
				chart: false,
				piechart: false,
				isSuccess: false,
			},
			charttype: 'linechart', //barchart //linechart
			reportdata: [],
			chartdata: [],
			piechartdata: [],
			showchart: false,
			stationList: [],
			branchlistsender:[],
			branchlistrecipient:[],
			//category: '',
			options: {
				area:[
					{ value: "", name: "ALL" },
					{ value: "1", name: "1" },
					{ value: "2", name: "2" },
					{ value: "3", name: "3" },
					{ value: "4", name: "4" },
					{ value: "5", name: "5" },
				],
			},
			pickerOptions: {
				shortcuts: [{
					text: 'Last week',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last month',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last 3 months',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
					picker.$emit('pick', [start, end]);
					}
				}]
			},

			sss: {
				year: {
					lastyear: '0',
					thisyear: '0',
					alerttype: 'error', //success
					comparisonresult: '0',
				},
				month: {
					lastmonth: '0',
					thismonth: '0',
					alerttype: 'error', //success
					comparisonresult: '0',
				},
				week: {
					lastweek: '0',
					thisweek: '0',
					alerttype: 'error', //success
					comparisonresult: '0',
				},
			},

			urlRequestParams: '',
			//branch: this.$route.query.branch ? this.$route.query.branch : '',
			//tabIndex: this.$route.query.tab ? this.$route.query.tab : 2,
			area: this.$route.query.area ? this.$route.query.area : '',
			status: this.$route.query.status ? this.$route.query.status : '',
		}
	},
	watch:
	{
		//area() { this.resumePilihan() },
		//status(){ this.resumePilihan() },
	},
    mounted()
    {
		Array.from(document.querySelectorAll('aside li.nav-item a')).map((e)=>{e.classList.remove('active')})
        document.querySelector('li.nav-item a.'+window.location.pathname.split('/')[1]).classList.add('active')

        this.$emit('childrenRoute');

		//this.getStationList()
		//this.loadStoreList2()
		this.getBranchList('sender')
		this.getBranchList('recipient')

		this.getItemQuota()

    },
    methods:{
		floatingSearchForm(){
			document.querySelector('.search.form').classList.toggle('floating')
		},
		searchFilterButtonClick(){
			document.querySelector('li.filter').classList.toggle('down')
			var select=document.querySelectorAll('.search.form')
			Array.from(select).map((e)=>{e.classList.toggle('minimize')})
		},

		async getItemQuota() {
			this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/bright/supply-chain/item-quota?'

			this.urlRequestParams+='&branch='+this.filter.branch
			this.urlRequestParams+='&branchto='+this.filter.branchto

			if (this.filter.dateRange !== null && this.filter.dateRange.length > 0) {
				this.urlRequestParams+='&startDate='+ this.filter.dateRange[0]
				this.urlRequestParams+='&endDate='+ this.filter.dateRange[1]
			}

			this.loading.table = true
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					this.reportdata = response.data;
					this.loading.isSuccess = true;

					//set barchart
					let legend = "legend";
					let label = "date";
					let valuecol = "QuotaSisa";
					let prefix = "";

					this.chartdata = this.processBarChart(response.data.data, legend, prefix, valuecol, false, label, "", 1, 2, Rainbow, false, false, false);
				})
				.catch(error => {
					//console.log(error)
				})
				.finally(() => {
					this.loading.table = false;
				})
        },

		async getBaselineComparison() {
			this.urlRequestParams=Config().apiURL
			if (this.tabName == 'commercial') this.urlRequestParams+='/bright/baseline?'
			else if (this.tabName == 'operational') this.urlRequestParams+='/bright/baseline-operational?'
			else if (this.tabName == 'supplychain') {
				if(this.filter.metric == 'DC_SERVICE_LEVEL') {
					this.urlRequestParams+='/bright/baseline-supplychain-dsl?'
				} else {
					this.urlRequestParams+='/bright/baseline-supplychain?'
				}
			}
			else if (this.tabName == 'tracking_process_pb') {
				this.urlRequestParams+='/bright/baseline/tracking-pb?'
			}

			this.urlRequestParams+='&branch='+this.filter.branch
			this.urlRequestParams+='&branchto='+this.filter.branchto
			if (this.filter.dateRange !== null && this.filter.dateRange.length > 0) {
			this.urlRequestParams+='&startDate='+ this.filter.dateRange[0]
			this.urlRequestParams+='&endDate='+  this.filter.dateRange[1]
			}
			this.urlRequestParams+='&metrics='+this.filter.metric
			this.urlRequestParams+='&area='+this.area
			this.urlRequestParams+='&category='+this.filter.category

			this.loading.table = true
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					let legend = "groupmembername";
					let label = "posdate";
					let valuecol = "totaltransaction";
					let prefix = "";

					if (this.tabName == 'operational') {
						legend = "SubMetricsName";
						label = "date";
						valuecol = "total";
						prefix = "";
					} else if (this.tabName == 'supplychain') {
						if(this.filter.metric == 'DC_SERVICE_LEVEL') {
							legend = "SubMetricsName";
							label = "PBDate";
							valuecol = "CompleteOrderinPercentage";
							prefix = "";
						} else {
							legend = "SubMetricsName";
							label = "date";
							valuecol = "CountItemOOS";
							prefix = "";
						}
					} else if(this.tabName == 'tracking_process_pb') {
						legend = "SubMetricsName";
						label = "date";
						valuecol = "total";
						prefix = "";
					}

					this.chartdata = this.processBarChart(response.data.data, legend, prefix, valuecol, false, label, "", 1, 2, Rainbow, false, false, false);
					this.reportdata = response.data;
					this.loading.table = false
					this.loading.isSuccess = true;
					//console.log('data: ' + JSON.stringify(this.chartdata));
				})
				.catch(error => {
					//console.log('err: ' + error)
				})
				.finally(() => {
					this.loading.table = false;
				})
        },

		getPiechartTrackingProcessPB() {
			this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/bright/baseline/tracking-pb-piechart?'

			//this.urlRequestParams+='&date-range-start='+this.date.Start
			//this.urlRequestParams+='&date-range-end='+this.date.End
			this.urlRequestParams+='&branch='+this.filter.branch
			this.urlRequestParams+='&branchto='+this.filter.branchto
			if (this.filter.dateRange !== null && this.filter.dateRange.length > 0) {
			this.urlRequestParams+='&startDate='+ this.filter.dateRange[0]
			this.urlRequestParams+='&endDate='+ this.filter.dateRange[1]
			}

			this.loading.piechart = true;
			AxiosWithJar().get(this.urlRequestParams)
			.then((response)=>{
				//this.chartresponsedata = response.data.data;
				//this.chartdata = this.processBarChart(this.chartresponsedata, "legend", "", "price", false, "period", "", 1, 2, Rainbow, false, false, false, this.stacked);

				let responsedata = response.data.data

				let item = responsedata
				var warna = []
				let value = [];
				let idx = 0;
				for (var row in item) {
					//add color
					warna[item[row].pbstatus] = Rainbow[idx];//'#FFB22E'

					//add value
					let main = {
						transtype: item[row].pbstatus,
						amount: item[row].cnt,
					};

					value.push(main);
					idx++;
				}

				this.piechartdata = this.processPieChart(value, "amount", "transtype", 1, 2, warna);
			})
			.catch(/*error => {
					//console.log(error)
					//this.errored = true
					//error.response.data
			}*/)
			.finally(() => {
				this.loading.piechart = false;
			})

		},

		async getBranchList(deliveryName) {
			let url = Config().apiURL + "/bright/supply-chain/item-quota-branch-list";
			url+='?delivery-name='+deliveryName
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.data.length) {
					if(deliveryName == 'sender')
						this.branchlistsender = result.data.data;
					else
						this.branchlistrecipient = result.data.data;
					//console.log('this.store.list: ' + JSON.stringify(this.store.list))
				}
			})
		},

		applyFilter() {
			this.getItemQuota()
        },

		getStationList() {
			let stations = this.store.list;
			this.stationList = [];
			if(this.filter.metric == 'DC_SERVICE_LEVEL') {
				//this.stationList = [];
				for (let i = 0; i < stations.length; i++) {
					if(stations[i].BranchId == 'DHLCKG1' || stations[i].BranchId == 'DHLSBY1') {
						this.stationList.push(stations[i]);
					}
				}
			} else {
				for (let i = 0; i < stations.length; i++) {
					this.stationList.push(stations[i]);
				}
			}
		}
    }
}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>
